import FilterForm from 'components/forms/FilterForm';
import { DatePicker, Form, FormProps, Input } from 'antd';

export interface IContractStudentFilter {
  by_user_name: string;
  by_user_email: string;
  created_after: Date;
  created_before: Date;
}

interface ContractsFilterProps {
  searchFormProps: FormProps<IContractStudentFilter>;
}

export const ContractStudentsFilter = ({
  searchFormProps
}: ContractsFilterProps) => {
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="by_user_name">
        <Input placeholder="Nome do aluno" />
      </Form.Item>

      <Form.Item name="by_user_email">
        <Input placeholder="E-mail do aluno" />
      </Form.Item>

      <Form.Item name="created_after">
        <DatePicker
          format="DD/MM/YYYY"
          placeholder="Inclusão (a partir de)"
          allowClear
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name="created_before">
        <DatePicker
          format="DD/MM/YYYY"
          placeholder="Inclusão (término em)"
          allowClear
          style={{ width: '100%' }}
        />
      </Form.Item>
    </FilterForm>
  );
};
